import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { useEffect, useRef, useState } from "react";
import { Button, DialogActions } from "@mui/material";
import dayjs from "dayjs";

export default function TimePicker(props) {
  const [value, setValue] = useState();
  const timeInputRef = useRef();
  // const [max, setMax] = useState(false)
  // const [min, setMin] = useState(false)
  function acceptHandler(params) {
    setValue(params);
    let time =
      params.$m === 0 ? params.$H.toString() : params.$H + ":" + params.$m;
    if (props.HasManyInputData) {
      props.HasManyInputData(props.index, props.HasManyKey, time);
    } else {
      let object = props.inputData;
      object[props.keyValue] = time;
      props.setInputData(object);
    }
  }

  useEffect(() => {
    if (props.pageType === "edit") {
      // Assuming props.inputData contains the initial time value
      const initialTime = props.inputData[props.keyValue];
      if (initialTime) {
        // Convert initialTime to a dayjs object
        const timeParts = initialTime.split(":");
        const hours = parseInt(timeParts[0], 10);
        const minutes = timeParts.length > 1 ? parseInt(timeParts[1], 10) : 0;
        setValue(dayjs().hour(hours).minute(minutes));
      }
    }
  }, [props.pageType, props.inputData, props.keyValue]);

  // useEffect(() => {
  //     if (props.maxTime) {
  //         setMax(dayjs().set('hour', props.maxTime))
  //     }
  //     if (props.minTime) {
  //         setMin(dayjs().set('hour', props.minTime))
  //     }
  // }, [])

  const MyActionBar = ({ onAccept, onCancel }) => {
    return (
      <DialogActions
        className={
          "MuiDialogActions-root MuiDialogActions-spacing MuiPickersLayout-actionBar css-hlj6pa-MuiDialogActions-root"
        }
      >
        <Button
          className={
            "MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-1e6y48t-MuiButtonBase-root-MuiButton-root"
          }
          onClick={onCancel}
        >
          {" "}
          لغو{" "}
        </Button>
        <Button
          className={
            "MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-1e6y48t-MuiButtonBase-root-MuiButton-root"
          }
          onClick={onAccept}
        >
          {" "}
          ثبت{" "}
        </Button>
      </DialogActions>
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileTimePicker
        components={{ ActionBar: MyActionBar }}
        value={value}
        onAccept={(newValue) => acceptHandler(newValue)}
        ampm={props.ampm}
        ampmInClock={false}
        minutesStep={5}
        disabled={false}
        readOnly={false}
        inputRef={timeInputRef}
        className="dark:bg-[#ffffffdd] rounded-md"
        // maxTime={max}
        // minTime={min}
      />
    </LocalizationProvider>
  );
}
